export const PaymentMethodLabel = {
  0: 'efectivo',  
  1: 'transferencia electrónica',
  2: 'banco',
  3: 'caja chica',
  4: 'otro'
};
